import { Fetch } from '../helpers/fetchWrapper';

const COMMON_API_URL = process.env.REACT_APP_COMMON_API_URL;

let configPromise = null;

async function readJson(res, fallbackMessage) {
  if (res.status >= 200 && res.status < 300) return res.json();
  let message = fallbackMessage;
  try {
    ({ message } = await res.json());
  } catch {
    // Preserve the fallback when the response body is not valid JSON.
  }
  throw new Error(message || fallbackMessage);
}

export function getRuntimeConfig() {
  if (!configPromise) {
    configPromise = Fetch.get(`${COMMON_API_URL}/client-config`)
      .then(res => readJson(res, 'Could not load application configuration.'))
      .then(body => body.data)
      .catch(err => {
        configPromise = null;
        throw err;
      });
  }
  return configPromise;
}

export function resetRuntimeConfig() {
  configPromise = null;
}

export async function getBrokerCredentials() {
  const res = await Fetch.get(`${COMMON_API_URL}/mqtt/credentials`);
  const body = await readJson(res, 'Could not obtain message broker credentials.');
  return body.data;
}

export async function searchAddresses(input, { country, sessiontoken } = {}) {
  const params = new URLSearchParams({ input });
  if (country) params.set('country', country);
  if (sessiontoken) params.set('sessiontoken', sessiontoken);

  const res = await Fetch.get(`${COMMON_API_URL}/maps/autocomplete?${params.toString()}`);
  const body = await readJson(res, 'Address lookup failed.');
  return body.data;
}

export async function getPlaceDetails(placeId, { sessiontoken } = {}) {
  const params = new URLSearchParams({ place_id: placeId });
  if (sessiontoken) params.set('sessiontoken', sessiontoken);

  const res = await Fetch.get(`${COMMON_API_URL}/maps/place-details?${params.toString()}`);
  const body = await readJson(res, 'Address lookup failed.');
  return body.data;
}

export default { getRuntimeConfig, resetRuntimeConfig, getBrokerCredentials, searchAddresses, getPlaceDetails };
